
import { defineComponent } from 'vue';
import EditPartnerRegions from '@/views/PartnerRegions/EditPartnerRegions.vue';

export default defineComponent({
    components: { EditPartnerRegions },
});
